const headerBarClass = 'c-header-bar';
const buttonClass = headerBarClass + '__button';
const buttonActiveClass = buttonClass + '--active';

const headerBarJsClass = 'js-header-bar';
const menuButtonJsClass = headerBarJsClass + '-menu-button';
const shortcutsMenuButtonJsClass = headerBarJsClass + '-shortcuts-button';

const menuButtonElement = document.querySelector('.' + menuButtonJsClass);
const shortcutsMenuButtonElement = document.querySelector('.' + shortcutsMenuButtonJsClass);

export function activateMenuButton (): void {
    // If the button is not already active
    if (!menuButtonElement.classList.contains(buttonActiveClass)) {
        // We activate it
        menuButtonElement.classList.add(buttonActiveClass);
        menuButtonElement.setAttribute('aria-expanded', 'true');
    }
}

export function deactivateMenuButton (): void {
    // If the button is active
    if (menuButtonElement.classList.contains(buttonActiveClass)) {
        // We deactivate it
        menuButtonElement.classList.remove(buttonActiveClass);
        menuButtonElement.setAttribute('aria-expanded', 'false');
    }
}

export function activateShortcutsMenuButton (): void {
    // If the button is not already active
    if (!shortcutsMenuButtonElement.classList.contains(buttonActiveClass)) {
        // We activate it
        shortcutsMenuButtonElement.classList.add(buttonActiveClass);
        shortcutsMenuButtonElement.setAttribute('aria-expanded', 'true');
    }
}

export function deactivateShortcutsMenuButton (): void {
    // If the button is active
    if (shortcutsMenuButtonElement.classList.contains(buttonActiveClass)) {
        // We deactivate it
        shortcutsMenuButtonElement.classList.remove(buttonActiveClass);
        shortcutsMenuButtonElement.setAttribute('aria-expanded', 'false');
    }
}